import { selectUser } from '@/shared/redux/api/auth/auth-api';
import store from '@/shared/redux/store/store';
import { TCustomRouteObject } from '@/shared/types/router.types';

import { Home } from './home';

export const homeRoutes: TCustomRouteObject = {
  path: '',
  element: <Home />,
  loader: () => {
    const user = selectUser(store.getState());

    if (!user) {
      return null;
    }
  },
  handle: {
    crumb: {
      label: 'home',
      localized: true,
    },
  },
};
